import { useState } from "react";
import { Store } from "lucide-react";
import AnimatedSection from "components/AnimatedSection";
import CustomButton from "components/CustomButton";
import { BtnVoltarHome } from "app/componentes/BtnVoltarHome";
import { prepareNuvemshopInstall } from "services/api";

export function NuvemshopConectar() {
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const handleConectar = async () => {
    setErro(null);
    setLoading(true);
    try {
      const { data } = await prepareNuvemshopInstall();
      window.location.href = data.authUrl;
    } catch (err: any) {
      setErro(err?.response?.data?.erro || err?.message || "Falha ao iniciar conexão.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-bg px-4 py-10">
      <AnimatedSection className="w-full max-w-md text-center">
        <img
          src="/images/intrex_logo.png"
          alt="Intrex"
          className="h-11 mx-auto mb-5"
        />

        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-brand-primary">
          <Store className="h-7 w-7" />
        </div>

        <h2 className="text-xl font-bold text-slate-900 mb-2">Conectar loja Nuvemshop</h2>
        <p className="text-sm text-slate-500 mb-6">
          Conecte sua loja Nuvemshop à Intrex para calcular fretes internacionais
          automaticamente no checkout, com desconto UPS/FedEx.
        </p>

        {erro && (
          <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mb-4">
            {erro}
          </div>
        )}

        <CustomButton
          label={loading ? "Redirecionando..." : "Conectar loja Nuvemshop"}
          className="w-full"
          disabled={loading}
          onClick={handleConectar}
        />
      </AnimatedSection>

      <div className="mt-6">
        <BtnVoltarHome />
      </div>
    </div>
  );
}
